export default __webpack_public_path__ + "static/media/Agarose_Gel.688ca5c3.svg";